/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sales_My_RevenueInputs */

const vi_dashboard_sales_my_revenue = /** @type {(inputs: Dashboard_Sales_My_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doanh số cá nhân`)
};

/**

* @param {Dashboard_Sales_My_RevenueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_sales_my_revenue = /** @type {((inputs?: Dashboard_Sales_My_RevenueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sales_My_RevenueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_sales_my_revenue(inputs)
});